<template>
  <div class="line-item-v2">
    <div class="d-flex mb-3 align-center justify-space-between flex-wrap">
      <div class="d-flex align-center">
        <v-autocomplete
          v-if="relatedType != 7"
          hide-details
          v-model.trim="module_type"
          :items="modulesType"
          clearable
          v-on:click:clear="module_type = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event)"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
        <v-btn-toggle color="cyan" group>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="product"
            v-on:click="open_dialog('product')"
            v-if="relatedType != 7 && false"
          >
            Product
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="service"
            v-on:click="open_dialog('service')"
            v-if="relatedType != 7 && false"
          >
            Service
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="equipment"
            v-if="relatedType == 7"
            v-on:click="open_dialog('equipment')"
          >
            Customer Equipment
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="tools"
            v-on:click="open_dialog('tools')"
            v-if="relatedType != 7 && false"
          >
            Equipment/Tools
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            v-on:click="add_header()"
            style="height: 32px !important"
          >
            Header
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_other()"
            style="height: 32px !important"
            v-if="relatedType != 7"
          >
            Other
          </v-btn>
        </v-btn-toggle>
      </div>
      <div class="d-flex align-center flex-wrap">
        <v-checkbox
          v-if="!isEnquiry && !isInvoice"
          class="my-0 py-0 mr-3"
          v-model="show_price"
          v-on:change="emit_values()"
          color="cyan"
          hide-details
          label="Show Price To Engineer"
        />
        <div class="d-flex align-center ml-2 pl-3 custom-border-left">
          <label
            for="discount-level"
            class="mb-0 font-weight-600 font-size-13 color-custom-blue mr-2 text-nowrap"
            >Discount Level</label
          >
          <v-autocomplete
            :menu-props="{ offsetY: true }"
            :disabled="relatedDetail && relatedDetail.id > 0"
            hide-details
            v-model.trim="discount_level"
            :items="transactions"
            style="max-width: 180px !important"
            dense
            flat
            filled
            placeholder="Discount Level"
            item-color="cyan"
            class="custom-boder-color"
            color="cyan"
            solo
            v-on:change="calculate_total()"
            item-value="value"
            item-text="text"
          >
          </v-autocomplete>
        </div>
      </div>
    </div>

    <v-card
      flat
      outlined
      class="rounded-lg border-slate bg-white overflow-hidden mb-4 shadow-0"
    >
      <div class="d-flex grey lighten-4 border-bottom align-center px-3 py-2">
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center d-flex align-center justify-center"
          style="width: 4%"
        >
          #
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-left px-2 d-flex align-center"
          :style="{ width: discount_level == 'line_item' ? '39%' : '52%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-package-variant-closed</v-icon
          >
          <template v-if="relatedType == 7">Equipment</template>
          <template v-else>Product / Service / Equipment</template>
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-13 text-uppercase px-1 d-flex align-center justify-center text-center"
          style="width: 14%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-tag-outline</v-icon
          >
          Selling/Unit Cost
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 9%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-ruler-square</v-icon
          >
          UOM
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 9%"
        >
          <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
          Quantity
        </div>
        <div
          v-if="discount_level == 'line_item'"
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 13%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-percent-outline</v-icon
          >
          Discount
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 8%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-cash-multiple</v-icon
          >
          Total
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center"
          style="width: 4%"
        ></div>
      </div>
      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0 pa-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag border-bottom border-slate-100 hover:bg-slate-50 transition-fast pa-0"
            :class="{
              'alternate-line-item-row bg-slate-50':
                selected_line_items[index + 1]?.is_child,
            }"
            :key="`line-item-drag-${index}`"
          >
            <div
              :id="`line-item-drag-${index}`"
              class="d-flex align-top py-2 px-3"
              :class="{ 'item-is-child pl-4': row.is_child }"
            >
              <div class="font-weight-600 text-center" style="width: 4%">
                <v-icon
                  v-if="!row.is_child"
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.is_child"
                class="font-weight-600 text-center"
                style="width: 4%"
              >
                <v-icon
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.type == 'header'"
                class="text-left px-2"
                style="width: 96%"
              >
                <v-text-field
                  v-model="row.product"
                  class="line-item-header-text px-0"
                  placeholder="Header Title"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  v-on:change="changeName(index, row.product)"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-chip
                      color="cyan white--text"
                      label
                      small
                      class="lip-type text-uppercase font-weight-600 header"
                    >
                      Header
                    </v-chip>
                  </template>
                </v-text-field>
              </div>
              <div
                v-else
                class="text-left px-2"
                :style="{
                  width:
                    discount_level == 'line_item'
                      ? row.is_child
                        ? '34%'
                        : '39%'
                      : row.is_child
                      ? '47%'
                      : '52%',
                }"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    size="32"
                    v-if="row.product_type != 'other'"
                    class="rounded-lg border"
                  >
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-expansion-panels class="cepfli flat">
                      <v-expansion-panel class="bg-transparent">
                        <v-expansion-panel-header class="pa-0 min-height-unset">
                          <v-text-field
                            v-model="row.product"
                            class="line-item-header-text px-0"
                            placeholder="Product/Service/Equipment & Tools"
                            dense
                            filled
                            solo
                            v-on:change="changeName(index, row.product)"
                            flat
                            hide-details
                            color="cyan"
                          >
                            <template v-slot:append>
                              <v-chip
                                color="cyan white--text"
                                label
                                small
                                class="lip-type text-uppercase font-weight-600"
                                :class="{
                                  product: row.product_type == 'goods',
                                  service: row.product_type == 'service',
                                  equipment: row.product_type == 'equipment',
                                  tools: row.product_type == 'tools',
                                  parts: row.product_type == 'parts',
                                  other: row.product_type == 'other',
                                }"
                              >
                                <template v-if="row.type == 'tools'">
                                  Tools</template
                                >
                                <template v-else> {{ row.type }}</template>
                              </v-chip>
                              <template
                                v-if="
                                  row.product_type == 'goods' ||
                                  row.product_type == 'parts' ||
                                  row.type == 'product' ||
                                  row.type == 'parts'
                                "
                              >
                                <v-chip
                                  :color="
                                    row?.isSerialized
                                      ? 'green darken-1'
                                      : 'red lighten-1'
                                  "
                                  class="font-weight-600 ml-2"
                                  small
                                  label
                                  text-color="white"
                                >
                                  {{
                                    row?.isSerialized
                                      ? "Serialized"
                                      : "Non-serialized"
                                  }}
                                </v-chip>
                              </template>
                            </template>
                          </v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-0 pt-2">
                          <v-textarea
                            class="px-0 mb-0"
                            v-model="row.description"
                            placeholder="Description"
                            dense
                            filled
                            solo
                            flat
                            rows="2"
                            auto-grow
                            hide-details
                            color="cyan"
                            v-on:change="changeDes(index, row.description)"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div
                      class="d-flex align-center flex-wrap ml-0 mt-1"
                      v-if="row && row.cimages && row.cimages.length"
                    >
                      <div
                        style="position: relative"
                        v-for="(nimg, nmlindex) in row.cimages"
                        :key="`new-image-${nmlindex}`"
                      >
                        <v-img
                          :aspect-ratio="1"
                          height="80px"
                          width="80px"
                          class="mr-2 my-1 rounded-lg border"
                          :src="nimg"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey darken-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-btn
                          style="position: absolute; top: -5px; right: -5px"
                          icon
                          x-small
                          color="red darken-1"
                          v-on:click="removeImage(nmlindex, index)"
                        >
                          <v-icon small>mdi-close-circle</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div class="d-flex align-center flex-wrap ml-0 mt-1">
                      <v-chip
                        v-if="row.barcode"
                        label
                        color="cyan darken-3"
                        outlined
                        x-small
                        class="font-weight-700 mr-2"
                        v-on:click="routeToDetail(row)"
                        >{{ row.barcode }}</v-chip
                      >
                      <v-checkbox
                        v-if="row.type == 'product'"
                        color="cyan"
                        label="Add as equipment"
                        dense
                        class="pt-0 mt-0 ml-2"
                        v-model="row.is_equipment"
                        hide-details
                        :false-value="0"
                        :true-value="1"
                        v-on:change="changeEquipment(index, row.is_equipment)"
                      >
                      </v-checkbox>

                      <template
                        v-if="
                          row.product_type != 'goods' &&
                          row &&
                          row.has_warranty &&
                          row.has_warranty == 1 &&
                          row.warranty_status > 0
                        "
                      >
                        <v-chip
                          :color="getWarrantyStatusColor(row.warranty_status)"
                          x-small
                          text-color="white"
                          class="font-weight-600 mr-2"
                        >
                          Warranty
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0
                        "
                      >
                        <v-chip
                          color="red"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.preventive_barcode }}
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0 &&
                          showModules.preventive_maintanance
                        "
                      >
                        <v-chip
                          :color="row?.is_consumed ? 'red' : 'cyan darken-2'"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.location }}
                        </v-chip>
                      </template>

                      <div
                        v-if="row.has_property"
                        class="font-weight-600 d-flex align-center ml-2"
                      >
                        <v-btn
                          v-if="false && row?.property?.id"
                          v-on:click="remove_property(index)"
                          icon
                          x-small
                          color="red lighten-1"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                style="width: 14%"
              >
                <PriceField
                  class="line-item-header-text px-0"
                  placeholder="Selling/Unit Cost"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="text"
                  inputmode="decimal"
                  v-model="row.rate"
                  v-on:keyup="calculate_total()"
                  color="cyan"
                />
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                style="width: 9%"
              >
                <v-autocomplete
                  :menu-props="{ offsetY: true }"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="unitList"
                  placeholder="UOM"
                  solo
                  flat
                  hide-details
                  item-text="text"
                  item-value="value"
                  class="pr-0 width-100"
                  v-model.trim="row.uom"
                  v-on:change="emit_values()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No UOM Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                style="width: 9%"
              >
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Quantity"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  max="5000"
                  :maxlength="row.product_type == 'service' ? 4 : null"
                  :readonly="row.type == 'equipment' || row.type == 'tools'"
                  v-model="row.quantity"
                  :prepend="row.uom"
                  v-on:keyup="checkAvailableQuantity(row), calculate_total()"
                  v-on:keypress="
                    isNumber($event);
                    row.product_type == 'service' &&
                      limitMaxLength($event, row.quantity, 4);
                  "
                  color="cyan"
                />
                <v-btn
                  style="height: 20px !important"
                  v-if="
                    (false && row.product_type == 'goods') ||
                    (row.product_type == 'parts' && false)
                  "
                  class="custom-bold-button white--text"
                  v-on:click="optionSerial(row, index)"
                  color="cyan"
                  x-small
                >
                  Select Serial
                  <template v-if="row?.serialize_number?.length > 0">
                    ({{ row?.serialize_number?.length }})</template
                  >
                  <template v-else>
                    ({{ row?.serialNumber?.length ?? 0 }})</template
                  >
                </v-btn>
              </div>
              <div
                v-if="discount_level == 'line_item' && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 13%"
              >
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    type="number"
                    v-model="row.discount_value"
                    v-on:keyup="calculate_total()"
                    v-on:keypress="
                      limitDecimal($event, row.discount_value),
                        validateDiscountKeypress($event, row)
                    "
                    color="cyan"
                    style="width: 60%"
                    :disabled="row.quantity == 0"
                  />
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="row.discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType2(row)"
                    color="cyan"
                    style="width: 40%"
                  />
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                style="width: 8%"
              >
                <v-text-field
                  class="line-item-header-text px-0 font-weight-600"
                  placeholder="Total"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  v-model="row.total"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, row.total)"
                  color="cyan"
                />
              </div>
              <div
                class="font-weight-600 d-flex align-center justify-center"
                style="width: 4%"
              >
                <template v-if="!row.is_child">
                  <v-menu v-if="row.has_child" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        color="cyan darken-2"
                      >
                        <v-icon small
                          >mdi-dots-horizontal-circle-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="py-0 rounded-lg" min-width="160px">
                      <v-list-item
                        v-if="!row.is_child"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'equipment')"
                      >
                        <v-list-item-title class="font-weight-600">
                          Add Equipment</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        v-if="!row.is_child && relatedType != 7"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'product')"
                      >
                        <v-list-item-title class="font-weight-600">
                          Add Product</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        v-if="!row.is_child && relatedType != 7"
                        link
                        v-on:click="add_child(index, 'service')"
                      >
                        <v-list-item-title class="font-weight-600">
                          Add Service</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  v-on:click="remove_row(index)"
                  icon
                  small
                  color="red lighten-1"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="pa-6 text-center">
          <v-icon color="slate-300" large class="mb-2"
            >mdi-package-variant-closed text-slate-300</v-icon
          >
          <p class="m-0 font-size-15 font-weight-500 text-slate-500">
            No line items added yet. Use the buttons above to add items.
          </p>
        </div>
      </template>
    </v-card>

    <div
      v-if="false"
      class="d-flex align-center justify-space-between flex-wrap mb-4"
    >
      <div class="d-flex align-center mb-2">
        <v-autocomplete
          v-if="relatedType != 7"
          hide-details
          v-model.trim="module_type"
          :items="modulesType"
          clearable
          v-on:click:clear="module_type = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event)"
          item-value="value"
          class="mr-2 custom-boder-color"
          item-text="text"
        >
        </v-autocomplete>
        <v-btn-toggle color="cyan" group>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            v-on:click="add_header()"
            style="height: 32px !important"
          >
            Header
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_other()"
            style="height: 32px !important"
            v-if="relatedType != 7"
          >
            Other
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div>
      <table width="100%" style="table-layout: fixed">
        <tbody>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Sub Total
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(subtotal) }}
            </td>
          </tr>
          <tr v-if="discount_level == 'transaction'">
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Discount
            </td>
            <td width="15%" valign="middle" align="center">
              <div class="d-flex">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0"
                  placeholder="Discount"
                  dense
                  filled
                  solo
                  flat
                  v-model="discount_value"
                  v-on:keyup="calculate_total(), checkData()"
                  v-on:keypress="
                    limitDecimal($event, discount_value),
                      checkData(),
                      manageDiscount($event)
                  "
                  v-on:paste="validateTransactionDiscountPaste($event)"
                  v-on:change="checkData()"
                  color="cyan"
                />

                <v-select
                  :items="discount_type_list"
                  v-model="discount_type"
                  hide-details
                  item-text="type"
                  item-value="value"
                  item-color="cyan"
                  class="line-item-header-text discount-type text-h6 px-0"
                  placeholder="Type"
                  dense
                  filled
                  solo
                  flat
                  v-on:change="calculate_total(), changeDiscountType()"
                  color="cyan"
                />
              </div>
            </td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(discount) }}
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Tax [GST {{ gst_value }}%]
            </td>
            <td width="15%" valign="middle" align="center">
              <v-checkbox
                v-on:change="calculate_total()"
                v-model="tax_active"
                class="my-0 py-0 px-0 mx-0"
                color="cyan"
                :label="`Tax Amount: ${formatMoney(gst_amount)}`"
              />
            </td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(gst) }}
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Adjustment
            </td>
            <td width="15%" valign="middle" align="center">
              <v-text-field
                hide-details
                class="line-item-header-text px-0 line-item-adjustment"
                placeholder="Adjustment"
                dense
                filled
                solo
                flat
                v-model="adjustment"
                v-on:keyup="calculate_total()"
                v-on:keypress="
                  limitDecimal($event, adjustment),
                    limitMaxLength($event, adjustment, 10)
                "
                :maxlength="10"
                color="cyan"
              >
                <template v-slot:append>
                  <v-btn depressed v-on:click="auto_adjust()">Auto</v-btn>
                </template>
              </v-text-field>
            </td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(adjustment) }}
            </td>
          </tr>
          <tr class="font-size-19">
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Grand Total
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :product-dialog="product_dialog"
      :module-type="relatedType"
      v-on:update-values="update_line_item($event)"
      v-on:close="closeProductDialog"
    />
    <ManageWarranty
      :dialog-status="addWarrantyDialog"
      v-on:close:dialog="addWarrantyDialog = false"
      v-on:warrnty:data="warrantyData($event)"
    ></ManageWarranty>
    <AddressSelect
      line-item
      :key="`address-select-dialog-${dialog_key}`"
      :dialog="property_dialog"
      v-on:close="property_dialog = false"
      type="property"
      label="Service Location"
      v-on:update="update_child_property($event)"
    />
    <!-- Upload Image :: begin -->
    <div class="d-none">
      <v-file-input
        :ref="`line-item-image`"
        v-on:change="updateProfileImage"
        multiple
        accept="image/png, image/jpeg, image/jpg"
      ></v-file-input>
    </div>
    <SerialNumber
      v-if="seleceDialog"
      :transaction-detail="transactionDetail"
      :parent-index="numberIndex"
      :dialogStatus="seleceDialog"
      :serial-number="numbersArr"
      :local-entity="localEntity"
      v-on:close:dialog="seleceDialog = false"
      v-on:update:item="savedata"
    >
    </SerialNumber>
    <ManageUnit
      :u-dialog="manageUnitDialog"
      :unit="unitList"
      v-on:close-dialog="manageUnitDialog = false"
      v-on:get-product-unit="getOptions"
    ></ManageUnit>
    <!-- Upload Image :: end -->
    <Dialog :common-dialog="customerChangeDialog" :dialog-width="dialogWidth">
      <template v-slot:title>
        <v-layout class="px-4">
          <v-flex> Customer changed </v-flex>
        </v-layout>
      </template>
      <template v-slot:body>
        <div class="px-4 w-100">
          <p class="mb-0">
            The selected customer was changed and there are product line items
            in the current list. Would you like to keep the current product
            prices or update the prices for the newly selected customer?
          </p>
        </div>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="custom-bold-button custom-grey-border"
          text
          color="grey"
          @click="onKeepProductPrices"
          >Keep Prices</v-btn
        >
        <v-btn
          depressed
          class="custom-bold-button"
          color="cyan"
          dark
          text-color="white"
          @click="onUpdateProductPrices"
          >Update Prices</v-btn
        >
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY, GET, POST } from "@/core/services/store/request.module";
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import Dialog from "@/view/pages/partials/Dialog.vue";
import AddressSelect from "@/view/components/LineItemAddressSelect.vue";
import LineItemDialog from "@/view/components/LineItemDialog.vue";
import AppConfiguration from "@/core/config/app.config.js";
import SerialNumber from "@/view/pages/partials/Serial-Number-Select.vue";
import ManageUnit from "@/view/pages/partials/Manage-Part-Unit.vue";

import {
  SET_VISIT_LINE_ITEM,
  SET_VISIT_CALCULATION,
} from "@/core/services/store/visit.module";
import { toBtxNumber, toBtxFixed } from "@/core/services/common.service";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { find } from "lodash";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { v4 as uuidv4 } from "uuid";
import ManageWarranty from "@/view/pages/partials/Create-Warranty-Intenal.vue";

export default {
  name: "line-item-v1",
  mixins: [CommonMixin],
  data() {
    return {
      drag: false,
      dialog_key: Number(new Date()),
      product_type: null,
      manageUnitDialog: false,
      unitList: [],
      product_dialog: false,
      child_index: null,
      addWarrantyDialog: false,

      loadedSources: [],
      previousSources: [],
      inFlightSources: new Set(),
      loadedDetailId: null,

      pageLoading: false,
      append_child: false,
      transactionDetail: {},
      numbersArr: [],
      localEntity: [],
      seleceDialog: false,
      numberIndex: 0,
      warrantyObject: {},
      property_dialog: false,
      tax_active: false,
      payment: null,
      milestoneQueryData: {
        quotation: null,
        milestone: null,
        milestone_amount: null,
        milestone_amount_persentage: null,
        quotation_total: null,
        quotation_barcode: null,
        milestone_name: null,
        amount_type: null,
        quotation_date: null,
      },
      do_update: 0,
      show_price: false,
      transactions: [
        {
          text: "Transaction",
          value: "transaction",
        },
        {
          text: "Line Item",
          value: "line_item",
        },
      ],
      discount_level: "transaction",
      imageRules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Image size should be less than 2 MB!",
      ],
      module_type: null,
      modulesType: [
        {
          value: "goods",
          text: "Product",
          show: false,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
        {
          value: "service",
          text: "Service",
          show: false,
        },
        {
          value: "equipment",
          text: "Equipment",
          show: false,
        },
      ],
      imageSrc: [],
      selected_line_items: [],
      currentEntityDb: {},
      subtotal: 0,
      discount: 0,
      gst: 0,
      gst_amount: 0,
      gst_value: 9,
      adjustment: 0,
      total: 0,
      customIndex: 0,
      discount_value: null,
      discount_type: 1,
      customerChangeDialog: false,
      pendingNewCustomerId: null,
      previousCustomerId: null,
      discount_type_list: [
        { type: "%", value: 2 },
        { type: "$", value: 1 },
      ],
    };
  },
  props: {
    relatedDetail: {
      type: [Array, Object],
      default: null,
    },
    unit: {
      type: Array,
      default() {
        return [];
      },
      dbLineItems: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    dbEquipments: {
      type: Array,
      default() {
        return [];
      },
    },
    entityId: {
      type: Number,
      default: 0,
    },
    isJob: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 3,
    },
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    subtotal(newVal) {
      if (this.discount_level === "transaction" && toBtxNumber(newVal) == 0) {
        this.discount_value = 0;
        this.calculate_total();
      }
    },
    selected_line_items: {
      deep: true,
      handler(items) {
        items.forEach((row) => {
          const qty = toBtxNumber(row.quantity);
          const rate = toBtxNumber(row.rate);
          const lineTotal = qty * rate;

          if (qty <= 0) {
            row.discount_value = null;
            row.total = 0;
            return;
          }

          if (row.discount_type == 1 && row.discount_value > lineTotal) {
            row.discount_value = 0;
          }

          if (row.discount_type == 2 && row.discount_value > 100) {
            row.discount_value = 100;
          }
        });
      },
    },
    vCustomerId(newCustomerId) {
      if (!newCustomerId) {
        return;
      }

      const oldCustomerId = this.previousCustomerId;

      if (newCustomerId !== oldCustomerId) {
        const hasProducts = this.selected_line_items.some((item) => {
          if (!item) {
            return false;
          }

          const productType = (item.product_type || "")
            .toString()
            .toLowerCase();

          return ["goods", "product"].includes(productType);
        });

        if (hasProducts) {
          this.pendingNewCustomerId = newCustomerId;
          this.customerChangeDialog = true;
          return;
        }

        this.selected_line_items = this.selected_line_items.filter(
          (item) => item.product_type !== "equipment"
        );
        this.calculate_total();
        this.emit_values();
      }

      // Always update previousCustomerId once we have a real value
      this.previousCustomerId = newCustomerId;
    },
    relatedDetail: {
      deep: true,
      immediate: true,
      handler(param) {
        // Allow empty arrays to flow through
        if (param === null || param === undefined) return;

        if (param && param.id && param.id > 0) {
          this.get_line_items(param);
        } else if (Array.isArray(param)) {
          this.getMultipleLineItems(param);
        }
      },
    },
    /*  warrantyObject: {
        deep: true,
        immediate: true,
        handler(param) {
          console.log(param, "paramparamparam");
      
        },
      }, */
  },
  methods: {
    validateSellingCostInput(event) {
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Home",
          "End",
          "Tab",
          "Enter",
          "Escape",
          "Shift",
        ].includes(event.key)
      ) {
        return;
      }

      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const nextValue = value.slice(0, start) + event.key + value.slice(end);

      if (
        event.key.length !== 1 ||
        !/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)
      ) {
        event.preventDefault();
      }
    },
    validateSellingCostPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue = value.slice(0, start) + pastedValue + value.slice(end);

      if (!/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
      }
    },
    async getMultipleLineItems(items) {
      this.loading = true;

      try {
        if (!this.loadedSources) {
          this.loadedSources = [];
        }
        if (!this.inFlightSources) {
          this.inFlightSources = new Set();
        }

        const currentSources = items.map(
          (item) => `${item.source_type}_${item.id}`
        );

        // Remove items from deselected sources
        if (this.previousSources && this.previousSources.length > 0) {
          const deselectedSources = this.previousSources.filter(
            (src) => !currentSources.includes(src)
          );

          if (deselectedSources.length > 0) {
            // Filter out items that have deselected _source_key
            this.selected_line_items = this.selected_line_items.filter(
              (item) => !deselectedSources.includes(item._source_key)
            );

            // Clear these sources from loadedSources so they can be re-fetched if re-selected
            deselectedSources.forEach((source) => {
              const index = this.loadedSources.indexOf(source);
              if (index !== -1) {
                this.loadedSources.splice(index, 1);
              }
              if (this.inFlightSources) {
                this.inFlightSources.delete(source);
              }
            });
          }
        }

        // Fetch and add from new sources
        let newLineItems = [];
        for (let item of items) {
          const sourceKey = `${item.source_type}_${item.id}`;

          if (
            !this.loadedSources.includes(sourceKey) &&
            !this.inFlightSources.has(sourceKey)
          ) {
            this.inFlightSources.add(sourceKey);

            // When source is a visit (source_type == 3), the API expects the ticket id
            // so prefer item.ticket when available, otherwise fall back to item.id
            const sourceId =
              Number(item.source_type) === 3 ? item.ticket ?? item.id : item.id;

            try {
              const { data } = await this.$store.dispatch(QUERY, {
                url: `visit-v1/${sourceId}/line-items`,
                data: { type: item.source_type },
              });

              if (data?.length) {
                data.forEach((lineItem) => {
                  lineItem._source_key = sourceKey;
                });
                newLineItems.push(...data);
              }

              this.loadedSources.push(sourceKey);
            } finally {
              if (this.inFlightSources) {
                this.inFlightSources.delete(sourceKey);
              }
            }
          }
        }

        // Merge new items
        const existingItems = this.selected_line_items || [];
        this.selected_line_items = [...existingItems, ...newLineItems];

        // Update tracking to current sources
        this.previousSources = currentSources;

        this.calculate_total();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    validateDiscountKeypress(event, row) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (allowedKeys.includes(event.key)) return;

      const currentValue = event.target.value || "";
      const nextValue = Number(currentValue + event.key);

      // % discount → max 100 ONLY
      if (row.discount_type == 2) {
        if (nextValue > 100) {
          event.preventDefault();
        }
        return;
      }

      // flat discount → max rate
      const rate = Number(row.rate || 0);
      if (nextValue > rate) {
        event.preventDefault();
      }
    },
    changeDiscountType2(row) {
      if (row.discount_type == 2) {
        if (Number(row.discount_value) > 100) {
          row.discount_value = 100;
        }
      }

      // Flat discount
      if (row.discount_type == 1) {
        row.discount_value = 0;
      }

      this.calculate_total();
    },
    changeDiscountType() {
      if (this.discount_type == 2 && this.discount_value > 100) {
        this.discount_value = 100;
      }
      if (this.discount_type == 1) {
        this.discount_value = 0;
      }
      this.calculate_total();
    },
    manageDiscount($event) {
      const e = $event;
      const input = e.target;
      const key = e.key || String.fromCharCode(e.which || e.keyCode);
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          event.key
        )
      ) {
        return;
      }
      const newValue =
        input.value.substring(0, input.selectionStart) +
        key +
        input.value.substring(input.selectionEnd);
      if (isNaN(newValue)) {
        e.preventDefault();
        return;
      }
      if (
        (Number(newValue) > Number(this.subtotal) && this.discount_type == 1) ||
        (Number(newValue) > 100 && this.discount_type == 2)
      ) {
        e.preventDefault();
        return;
      }
    },
    validateTransactionDiscountPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue =
        value.substring(0, start) + pastedValue + value.substring(end);

      if (!/^\d*(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
        return;
      }

      const discountValue = Number(nextValue);
      const exceedsLimit =
        (this.discount_type == 1 && discountValue > Number(this.subtotal)) ||
        (this.discount_type == 2 && discountValue > 100);

      if (exceedsLimit) {
        event.preventDefault();
      }
    },
    UomData() {
      this.manageUnitDialog = true;
      this.getOptions();
    },
    onKeepProductPrices() {
      // Accept the new customer as the baseline even though prices are kept
      this.previousCustomerId = this.vCustomerId || this.pendingNewCustomerId;
      this.pendingNewCustomerId = null;
      this.customerChangeDialog = false;
      ErrorEventBus.$emit("update:info", "Keeping current product prices.");
    },
    onUpdateProductPrices() {
      const newCustomerId = this.vCustomerId;
      const oldCustomerId = this.previousCustomerId;

      const hasGoods = this.selected_line_items.some(
        (it) =>
          (it.product_type || "").toString().toLowerCase() === "goods" ||
          (it.product_type || "").toString().toLowerCase() === "service"
      );

      if (newCustomerId != oldCustomerId && hasGoods) {
        const selectedProductsIds = this.selected_line_items
          .filter(
            (item) =>
              (item.product_type || "").toString().toLowerCase() === "goods"
          )
          .map((item) => Number(item.product_id || item.id || 0))
          .filter((id) => Number.isInteger(id) && id > 0);
        const selectedServiceIds = this.selected_line_items
          .filter(
            (item) =>
              (item.product_type || "").toString().toLowerCase() === "service"
          )
          .map((item) => Number(item.product_id || item.id || 0))
          .filter((id) => Number.isInteger(id) && id > 0);
        if (!selectedProductsIds.length && !selectedServiceIds.length) {
          this.customerChangeDialog = false;
          this.pendingNewCustomerId = null;
          return;
        }

        this.$store
          .dispatch(POST, {
            url: `product/find-line-items/${newCustomerId}`,
            data: {
              product_ids: selectedProductsIds,
              service_ids: selectedServiceIds,
            },
          })
          .then(({ data }) => {
            const updatedLineItems = data?.line_items || [];

            if (!updatedLineItems.length) {
              this.customerChangeDialog = false;
              this.pendingNewCustomerId = null;
              return;
            }

            const updatedMap = {};
            updatedLineItems.forEach((updatedItem) => {
              updatedMap[Number(updatedItem.product_id)] = updatedItem;
            });

            this.selected_line_items.forEach((item) => {
              if (
                (item.product_type || "").toString().toLowerCase() !== "goods"
              ) {
                return;
              }

              const updatedItem = updatedMap[Number(item.product_id || 0)];
              if (!updatedItem) {
                return;
              }

              item.rate = updatedItem.rate;
              item.selling_cost = updatedItem.selling_cost;
              item.project_price = updatedItem.project_price;
              item.threshold_price = updatedItem.threshold_price;
              item.product = updatedItem.product;
              item.product_id = updatedItem.product_id;
              item.product_type = updatedItem.product_type;
              item.barcode = updatedItem.barcode;
              item.description = updatedItem.description;
              item.uom = updatedItem.uom;
              item.has_warranty = updatedItem.has_warranty;
            });

            this.calculate_total();
            this.emit_values();
            ErrorEventBus.$emit(
              "update:success",
              "Product prices updated based on new customer."
            );
          })
          .catch((error) => {
            console.error(
              "Error occurred while fetching updated line items:",
              error
            );
            ErrorEventBus.$emit(
              "update:error",
              "Failed to update product prices. Please try again."
            );
          })
          .finally(() => {
            // Update baseline so next customer change is detected correctly
            this.previousCustomerId = this.vCustomerId;
            this.customerChangeDialog = false;
            this.pendingNewCustomerId = null;
          });
      }
    },
    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "setting/get-all-unit",
        })
        .then((response) => {
          _this.unitList = response.data;
          _this.$emit("close-dialog", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    savedata(data) {
      this.selected_line_items[data.index].serialNumber = data.data;
      this.localEntity = data.data;
      this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
      this.seleceDialog = false;
    },
    optionSerial(row, index) {
      this.transactionDetail = row;
      this.numbersArr = row.serial_numbers_input;
      this.numberIndex = index;
      this.seleceDialog = true;
    },
    checkAvailableQuantity(row) {
      if (Number(row.quantity) > 5000) {
        ErrorEventBus.$emit("update:error", "Quantity cannot exceed 5000");
        row.quantity = 5000;
      }
    },
    getMileStoneMsg() {
      let messageDoller = "";
      if (
        this.payment &&
        this.payment == "partially_payment" &&
        this.milestoneQueryData?.amount_type == 1
      ) {
        messageDoller = `${this.formatMoney(
          this.milestoneQueryData?.milestone_amount
        )} for ${
          this.milestoneQueryData?.milestone_name
        } milestone of Quotation ${
          this.milestoneQueryData?.quotation_barcode
        } dated ${
          this.milestoneQueryData?.quotation_date
        } of total amount ${this.formatMoney(
          this.milestoneQueryData?.quotation_total
        )}`;
        return messageDoller;
      } else {
        messageDoller = `${
          this.milestoneQueryData?.milestone_amount_persentage
        }% (${this.formatMoney(
          this.milestoneQueryData?.milestone_amount
        )}) for ${
          this.milestoneQueryData?.milestone_name
        } milestone of Quotation ${
          this.milestoneQueryData?.quotation_barcode
        } dated ${
          this.milestoneQueryData?.quotation_date
        } of total amount ${this.formatMoney(
          this.milestoneQueryData?.quotation_total
        )}`;
        return messageDoller;
      }
    },
    partialPayment(row) {
      if (
        this.payment &&
        this.payment == "partially_payment" &&
        row.product_type == "other" &&
        row.product
      ) {
        return true;
      }
      return false;
    },
    selectImage(index) {
      this.customIndex = index;
      this.$refs[`line-item-image`].$refs["input"].click();
    },
    async updateProfileImage(param) {
      if (param && param.length) {
        const promises = [];
        for (let i = 0; i < param.length; i++) {
          const image = await this.convertImageToBase64(param[i]);
          promises.push(image);
        }
        const lineItems = this.lodash.cloneDeep(this.selected_line_items);
        const _cimage = lineItems[this.customIndex].cimages
          ? lineItems[this.customIndex].cimages
          : [];
        lineItems[this.customIndex].cimages = [..._cimage, ...promises];
        this.selected_line_items = lineItems;
        this.$nextTick(() => {
          this.emit_values();
        });
        this.$refs[`line-item-image`].$refs["input"].value = null;
        this.imageSrc = [];
      }
    },
    convertImageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrc.push(reader.result);
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    removeImage(index, pIndex) {
      this.selected_line_items[pIndex].cimages.splice(index, 1);
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    auto_adjust() {
      let total = toBtxNumber(this.total);
      if (total > 0) {
        let adjustment = toBtxFixed(total / 10) * 10 - total;
        this.adjustment = toBtxFixed(adjustment);
        this.$nextTick(() => {
          this.calculate_total();
        });
      }
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    get_col_style(param, child) {
      let width = 46;
      if (param == "product") {
        if (!this.show_price) {
          width = 70;
        } else if (this.show_price) {
          width = 46;
          if (this.discount_level == "transaction") {
            width = 70;
          }
        }
      }
      return { width: child ? `${width - 5}%` : `${width}%` };
    },
    calculate_total() {
      let d_type = this.discount_level;

      this.subtotal = 0;
      this.discount = 0;
      this.gst = 0;
      this.gst_amount = 0;

      for (let i = 0; i < this.selected_line_items.length; i++) {
        let total = this.accountingToFixed(
          toBtxNumber(this.selected_line_items[i].quantity) *
            toBtxNumber(this.selected_line_items[i].rate)
        );
        let discount = 0;

        if (d_type == "line_item") {
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 1
          ) {
            discount = toBtxNumber(this.selected_line_items[i].discount_value);
          }
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 2
          ) {
            discount = this.accountingToFixed(
              (toBtxNumber(total) *
                toBtxNumber(this.selected_line_items[i].discount_value)) /
                100
            );
          }
        }
        this.selected_line_items[i].total =
          isNaN(total) || !total
            ? 0
            : toBtxNumber(total) - toBtxNumber(discount);
        this.subtotal = this.accountingToFixed(
          toBtxNumber(this.subtotal) +
            toBtxNumber(this.selected_line_items[i].total)
        );
      }

      let subtotal = this.subtotal;

      if (d_type == "transaction") {
        this.discount = 0;
        if (this.discount_type == 1) {
          this.discount = toBtxNumber(this.discount_value);
          if (this.discount > subtotal) {
            this.discount_value = 0;
            this.discount = 0;
          }
        }
        if (this.discount_type == 2) {
          this.discount = this.accountingToFixed(
            (toBtxNumber(subtotal) * toBtxNumber(this.discount_value)) / 100
          );
        }
      }

      subtotal = toBtxNumber(subtotal) - toBtxNumber(this.discount);

      if (this.tax_active) {
        this.gst_amount = subtotal;
        this.gst = this.accountingToFixed(
          (toBtxNumber(subtotal) * toBtxNumber(this.gst_value)) / 100
        );
      }

      subtotal = toBtxNumber(subtotal) + toBtxNumber(this.gst);

      this.total = this.accountingToFixed(
        toBtxNumber(subtotal) + toBtxNumber(this.adjustment)
      );
      this.emit_values();
    },
    closeProductDialog() {
      this.product_dialog = false;
      this.module_type = null;
    },
    update_line_item(param) {
      if (this.append_child) {
        let child_index = toBtxNumber(this.child_index);
        for (let item of param) {
          item.is_child = true;
          child_index = child_index + 1;
          this.selected_line_items = this.arrayInsert(
            this.selected_line_items,
            child_index,
            item
          );
        }
      } else {
        for (let item of param) {
          this.selected_line_items.push(item);
        }
      }

      this.calculate_total();

      this.$nextTick(() => {
        this.emit_values();
        this.product_dialog = false;
        this.append_child = false;
        this.product_type = null;
        this.child_index = null;
      });
    },
    remove_property(index) {
      this.selected_line_items[index].property = new Object();

      this.$nextTick(() => {
        this.emit_values();
      });
    },
    checkData() {
      if (this.discount_type == 2 && this.discount_value) {
        if (this.discount_value > 100) {
          this.discount_value = 100;
        }
      }
    },
    changeEquipment(index, row) {
      this.selected_line_items[index].is_equipment = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeDes(index, row) {
      this.selected_line_items[index].description = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeName(index, row) {
      this.selected_line_items[index].product = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    OpenchangeWarrnty(index) {
      this.eIndex = index;
      this.addWarrantyDialog = true;
    },
    warrantyData(data) {
      this.selected_line_items[this.eIndex].equipment_warranty = 0;
      this.selected_line_items[this.eIndex].warranty_cost = data.cost;
      this.selected_line_items[this.eIndex].warranty_description =
        data.description;
      this.selected_line_items[this.eIndex].warranty_duration = data.duration;
      this.selected_line_items[this.eIndex].warranty_duration_type =
        data.duration_type;
      this.selected_line_items[this.eIndex].warranty_end_date = data.end_date;
      this.selected_line_items[this.eIndex].warranty_start_date =
        data.start_date;
      this.selected_line_items[this.eIndex].warranty_unique_id = data.unique_id;
      this.selected_line_items[this.eIndex].warranty_type = data.warranty_type;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeWarrnty(index, row) {
      this.selected_line_items[index].equipment_warranty =
        row.equipment_warranty;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    update_child_property(row) {
      this.selected_line_items[this.child_index].property = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    add_child(index, type) {
      this.append_child = true;
      this.dialog_key = Number(new Date());
      this.child_index = index;
      if (type == "property" || type == "equipment" || type == "tools") {
        if (!this.vCustomerId && !type == "tools") {
          this.scrollToTop();
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "equipment") {
          this.product_type = type;
          this.product_dialog = true;
        } else if (type == "tools") {
          this.product_type = type;
          this.product_dialog = true;

          /*     this.property_dialog = true; */
        } else {
          this.property_dialog = true;
        }
      }
      if (type == "product" || type == "parts") {
        // enabling the adding parts for invoices line items as well
        this.product_type = type;
        this.product_dialog = true;
      }

      if (type == "service") {
        this.product_type = type;
        this.product_dialog = true;
      }
    },
    emit_values() {
      this.$nextTick(() => {
        this.$store.dispatch(SET_VISIT_CALCULATION, {
          discount_type: this.lodash.toSafeInteger(this.discount_type),
          discount_value: this.discount_value,
          tax_active: this.tax_active,
          adjustment: this.adjustment,
          show_price: this.show_price,
          discount_level: this.discount_level,
          tax_value: this.gst_value,
        });
        this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
      });
    },
    open_dialog(param) {
      if (!param) {
        return false;
      }

      if (param === "equipment" && !this.vCustomerId) {
        this.scrollToTop();
        ErrorEventBus.$emit("update:error", "Please Select Customer.");
        return false;
      }

      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
    },
    add_header() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: 0,
        order: len,
        type: "header",
        product_type: "header",
        is_child: false,
        has_child: false,
        has_property: false,
        product: null,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    add_other() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: null,
        image: {},
        order: len,
        serial_no: null,
        eq_model: null,
        location: null,
        group: null,
        discount: 0,
        type: "other",
        is_child: false,
        parent_uuid: null,
        has_child: true,
        has_property: true,
        property: {},
        group_primary: false,
        discount_value: 0,
        discount_type: 1,
        to_equipment: 0,
        product: null,
        project_price: 0,
        threshold_price: 0,
        product_id: 0,
        product_type: "other",
        description: null,
        has_warranty: false,
        warranty: {},
        rate: 0,
        selling_cost: 0,
        quantity: 1,
        uom: null,
        total: 0,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    get_line_items(param) {
      let id = param.id;
      if (this.$route?.query?.ticket > 0) {
        id = this.$route?.query?.ticket;
      }
      const detailKey = `${this.relatedType}_${id}`;
      if (this.loadedDetailId === detailKey) {
        return;
      }
      this.loadedDetailId = detailKey;
      this.loading = true;
      this.$store
        .dispatch(QUERY, {
          url: `visit-v1/${id}/line-items`,
          data: {
            type: this.relatedType,
          },
        })
        .then(({ data }) => {
          const existingItems = this.selected_line_items || [];
          this.selected_line_items = [...existingItems, ...(data || [])];
          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
            if (this.payment && this.payment == "partially_payment") {
              this.selected_line_items[index].rate = 0;
            }
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 1 ? "transaction" : "line_item";
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }
          if (this.payment && this.payment == "partially_payment") {
            let len = this.selected_line_items.length + 1;
            this.selected_line_items.push({
              status: true,
              index: uuidv4(),
              uuid: uuidv4(),
              id: null,
              image: {},
              order: len,
              serial_no: null,
              eq_model: null,
              location: null,
              group: null,
              discount: 0,
              type: "other",
              is_child: false,
              parent_uuid: null,
              has_child: true,
              has_property: true,
              property: {},
              group_primary: false,
              discount_value: 0,
              discount_type: 1,
              to_equipment: 0,
              product:
                this.payment && this.payment == "partially_payment"
                  ? this.getMileStoneMsg()
                  : null,
              project_price: 0,
              threshold_price: 0,
              product_id: 0,
              product_type: "other",
              description: null,
              has_warranty: false,
              warranty: {},
              rate: this.milestoneQueryData?.milestone_amount,
              selling_cost: 0,
              quantity: 1,
              uom: null,
              total: 0,
            });
            this.$nextTick(() => {
              this.product_type = null;
              this.emit_values();
            });
          }
          this.calculate_total();
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remove_row(index) {
      this.selected_line_items.splice(index, 1);
      this.calculate_total();
      this.emit_values();
    },
    isGSTAllowed() {
      const app_config = AppConfiguration.get();
      const { entity } = app_config;
      const currentEntity = find(entity, { id: this.entityId });
      this.currentEntityDb = currentEntity;
      this.gst_value = currentEntity.gstvalue > 0 ? currentEntity.gstvalue : 9;

      if (currentEntity) {
        if (currentEntity.gst) {
          if (this.isJob || this.isEnquiry) {
            this.tax_active = true;
            return true;
          } else {
            this.tax_active = false;
          }
        }
      }
      return true;
    },
  },
  components: {
    Draggable,
    LineItemDialog,
    AddressSelect,
    SerialNumber,
    ManageWarranty,
    ManageUnit,
    Dialog,
  },
  beforeMount() {
    this.payment = this.$route?.query?.payment;
    this.milestoneQueryData = this.$route?.query;
  },

  mounted() {
    this.do_update = this.lodash.toSafeInteger(this.$route.query.do_update);
    this.isGSTAllowed();
    this.getOptions();
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vStateLoading",
      "vLineItem",
      "vSelectedLineItem",
      "vLineItemAlpha",
      "vLineItemCategory",
      "vLocalMilestone",
    ]),
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
